module.exports = __webpack_public_path__ + "static/media/clay.9b85e96a.svg";